import styled from 'styled-components'
import { Radio } from 'antd'

export const Heading = styled.div`
  font-style: normal;
  font-weight: 600;
  font-size: 16px;
  line-height: 21px;
  color: #010e30;
`
export const SubHeading = styled.div`
  font-style: normal;
  font-weight: 500;
  font-size: 13px;
  line-height: 18px;
  color: #999fac;
  margin-top: 5px;
`

export const RadioGroup = styled(Radio.Group)`
  display: flex;
  width: 85%;
`
